import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import { getTheBestImageFormat } from '../../utils/common';
import YoutubePlayer from '../../common/YoutubePlayer';
import CloseModalButton from '../../common/Modal/Buttons/CloseModalButton';

export default function Modal(props) {
	return (
		<div className='project-popup '>
			<h1 className='project-popup__title '>CSV parsing app</h1>
			<p className='project-popup__description '>
				There are situations when you have large CSV files with millions of records
				and need a special tool to search and filter them. The tool consists of two
				core modules: <br />
				1) CSV parser. <br /> The parser can be started in the terminal via the
				following command: <i>npm start someFile.csv someDirectory</i>. <br />
				When one executes this command, the script recursively searches for all CSV
				files in all directories and subdirectories. Using the streams mechanism, the
				script parses every CSV file found and saves parsed data in the database.{' '}
				<br />
				2) Table app. <br /> This part is responsible for displaying and filtering
				the parsed data. It is developed with React.js and Material UI. The resulting
				database can contain millions of records, so AJAX lazy loading was carried
				out. Also, it's possible to download a new filtered CSV file.
			</p>
			<div className='project-popup__about '>
				<p>
					<span className='span-title '>Stack:</span>
					<span className='span-description '>
						React.js, Material UI, responsive web, Node.js + express, PostgreSQL +
						Sequelize
					</span>
				</p>
			</div>
			<div className='project-popup__videos'>
				<YoutubePlayer
					src='https://www.youtube.com/embed/6tBhY68nwM8'
					title='CSV parsing application'
				/>
			</div>
			<div className='project-popup__images '>
				<p className='image-description image-description--left '>
					Client's feedback from my{' '}
					<a
						href='https://www.upwork.com/freelancers/~019846d9384d3f1d18'
						target='_blank'
						rel='noopener noreferrer'
					>
						Upwork
					</a>{' '}
					account:{' '}
				</p>
				<ProgressiveImage
					src={getTheBestImageFormat({
						webp: './media/projects/csvparser/feedback/feedback.webp',
						backupImage: './media/projects/csvparser/feedback/feedback.png',
					})}
					placeholder='./media/loader.gif'
				>
					{(src) => (
						<img
							src={src}
							alt="CSV parser client's feedback"
							style={{
								border: '2px solid rgb(244, 244, 244)',
								padding: '5px 0 10px 1px',
							}}
						/>
					)}
				</ProgressiveImage>
			</div>
			<div className='project-popup__buttons '>
				<CloseModalButton onClose={props.closeModal} />
			</div>
		</div>
	);
}
